import Swiper from "swiper";
import { Scrollbar, Navigation } from "swiper/modules";


interface SwiperConfig {
    querySelector: string;
    isNavigation: boolean;
    isAdaptiveSize: boolean;
    navigationNextEl?: string;
    navigationPrevEl?: string;
}

export class SwiperSettings {
    public initialize(): void {
        const swiperSettingsItems: SwiperConfig[] = [
            {
                querySelector: '.functionality__comprehensive-protection-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.safety-reliability__content-lines',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.functionality__unified-interface-mobile-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.successful-implementation-stories__filter-panel-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.press-center__filter-panel-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.contacts__tiles-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.safety-functionality__comprehensive-protection-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.safety-functionality__unified-interface-mobile-wrap',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.history-successes',
                isNavigation: true,
                isAdaptiveSize: false
            },
            {
                querySelector: '.assistant-prices__catalog-wrap-columns',
                isNavigation: false,
                isAdaptiveSize: false
            },
            {
                querySelector: '.our-partners__filter-panel-wrap',
                isNavigation: false,
                isAdaptiveSize: false,
            },
        ];

        const setSizes = (windowSize: number) => {
            swiperSettingsItems.forEach((config) => {
                const htmlElement = document.querySelector(config.querySelector);
                if (htmlElement) {
                    const computedStyles = window.getComputedStyle(htmlElement);
                    if (computedStyles.getPropertyValue('display') !== 'none') {

                        const settings: Record<string, any> = {
                            modules: [Scrollbar, Navigation],
                            slidesPerView: 'auto',
                            spaceBetween: config.isAdaptiveSize ? (windowSize > 1023 ? 0 : 15) : 15,
                            grabCursor: true,
                            scrollbar: {
                                el: ".swiper-scrollbar",
                                draggable: true,
                                dragSize: 'auto'
                            },
                        };
                        if (config.isNavigation) {
                            const navigationConfig  = this.getNavigationConfig(config);
                            if (navigationConfig?.navigation) {
                                settings.navigation = navigationConfig.navigation;
                            }
                        }
                        new Swiper(config.querySelector, settings);
                    }
                }
            });
        };

        setSizes(window.outerWidth);
        window.addEventListener("resize", (event: UIEvent) => {
            const currentTarget: Window = event.currentTarget as Window;
            setSizes(currentTarget.innerWidth);
        });
    }

    private getNavigationConfig(config: SwiperConfig) {
        const nextEl = config.navigationNextEl || '.safety-functionality__control-next';
        const prevEl = config.navigationPrevEl || '.safety-functionality__control-prev';

        const nextBtn = document.querySelector(nextEl);
        const prevBtn = document.querySelector(prevEl);

        if (!nextBtn || !prevBtn) {
            return {};
        }

        return {
            navigation: {
                nextEl,
                prevEl
            }
        };
    }
}
